import React from 'react'
import { Form, Text } from 'components/forms'
import ClientSelector from 'components/forms/ClientSelector'
import Button from 'components/Button'
import { notEmpty } from 'helpers/validators'
import { useMutation } from '@apollo/client'
import createShopMutation from '../../gql/createShop'
import get from 'lodash/get'

const NewShop = ({ history }) => {
	const [createShop] = useMutation(createShopMutation)
	const handleCreateShop = fields => {
		createShop({
			variables: { fields },
			refetchQueries: ['clientTree'],
			update: (cache, { data }) => {
				const id = get(data, 'cashAssist.createShop.id')
				history.push({
					pathname: `/optionen/kasse/filiale/${id}`
				})
			}
		})
	}
	return(
		<Form onSubmit={handleCreateShop}>
			<ClientSelector lastNode='REGION' field='regionId' {...notEmpty()} />
			<Text label='Name' field='name' {...notEmpty()} />
			<Button type='submit' text='speichern' status='primary' size='small'/>
		</Form>
	)
}

export default NewShop
